import { useEffect} from 'react';
import { connect } from 'react-redux';

// Communication Player <=> Library - Party Mode Requests
function ConnectedPlayerWrapper({ socket, playerMessagePM }) {

  // New Message from the player to broadcast
  useEffect(() => {
    if (socket && playerMessagePM) {
      socket.emit("broadcast message player", playerMessagePM);
    }
  }, [socket, playerMessagePM])

  return null;
}

const PlayerWrapper = connect(
  state => ({
    socket: state.socketPM,
    playerMessagePM: state.playerMessagePM
  })
)(ConnectedPlayerWrapper);

export default PlayerWrapper;
